import * as React from 'react'
import Errors from './errors'
import FormGroup from './form-group'
import InputLabel from './input-label'
import Description from './description'
import { toCurrency, toDate, stripNonNumberCharacters  } from '../util'
import './standard-input.css'


export default class extends React.Component<any, any>{

    onChange(e){
        if(this.props.updateField){
            if(this.props.type === 'Number' || this.props.type === 'Currency' || this.props.type === 'Year' ||  this.props.type === 'Percent'){
                const newValue = stripNonNumberCharacters(e.target.value)
                this.props.updateField(this.props.field, newValue);
            }else if(this.props.type == "DateManual"){
                const newValue = toDate(e.target.value)
                this.props.updateField(this.props.field, newValue)
            }else{
                this.props.updateField(this.props.field, e.target.value);
            }
        }
    }

    
    onBlur(e){
        if(this.props.blurHack == true && this.props.value !== undefined){
            const value = this.props.value;
            const target = e.target;
            setTimeout(function(){
                target.value = value;
            }, 0)
        }
        if(this.props.onBlur){
            this.props.onBlur(this.props.field)
        }
    }


    getValue(value){
        if(this.props.type === "DateManual"){
            if(value === null || value === undefined || value === '') return value;
            value = toDate(value)
            return value
        }else if(this.props.type === "Currency"){
            if(value === null || value === undefined || value === '') return value;
            value = toCurrency(value);
            return value;
        }else{
            return value;
        }
    }
    

    render(){
        const props = this.props;
        
        const field = props.field || "";
        const label = props.label;
        const value = props.value; 
        const type = props.type;
        const errors = props.errors;
        const updateField = this.props.onUpdate;
        const enabled = props.enabled;
        const description = props.description;
        const inputProps = props.inputProps;
        const onChange = props.onChange;
        const inline = props.inline || false;
        const show = props.show;
        const onBlur = this.props.onBlur;
        const rows = this.props.rows;
        const placeholder = this.props.placeholder;
        const size = props.size || "col-sm-6";
        const help = props.help;

        if(show == null || show){
            return (
                <div className={"standard-input col-12 " + (!inline ? size : "")}>
                    <FormGroup field={ field } errors={ errors }>
                        <div className={"row" + (inline ? " d-flex align-items-center" : "")}>
                            <div className={ inline ? "col-12 col-sm-7" : "col-12"}>
                                <InputLabel field={ field } label={ label } help={ help } />
                            </div>

                                <div className={ "input-group " + (inline ? "col-12 col-sm-5" : "col-12")}>
                                
                                { type === "Currency" && 
                                    <span className="input-group-addon" >
                                        <i className="fa fa-usd" aria-hidden="true"></i>
                                    </span> 
                                }

                                { type === "Date" && 
                                    <span className="input-group-addon">
                                        <i className="fa fa-calendar" aria-hidden="true"></i>
                                    </span> 
                                }

                                { rows &&
                                <textarea
                                    className={" form-control"}
                                    rows={ rows }
                                    id={ field.replace(".", "-") }
                                    type={ type=="email" ? "email" : "text" }
                                    disabled={!enabled && enabled !== null && typeof(enabled) !== 'undefined'}
                                    value={ this.getValue(value) }
                                    placeholder={placeholder}
                                    onBlur={ this.onBlur.bind(this) }
                                    onChange={ this.onChange.bind(this) }
                                    { ...inputProps }
                                />
                                }

                                { !rows &&
                                <input
                                    className={" form-control"}
                                    id={ field.replace(".", "-") }
                                    type={ type=="email" ? "email" : "text" }
                                    disabled={!enabled && enabled !== null && typeof(enabled) !== 'undefined'}
                                    value={ this.getValue(value) }
                                    placeholder={placeholder}
                                    onBlur={ this.onBlur.bind(this) }
                                    onChange={ this.onChange.bind(this) }
                                    { ...inputProps }
                                />
                                }

                                { type === "Percent" && 
                                    <span className="input-group-addon">
                                        <i className="fa fa-percent" aria-hidden="true"></i>
                                    </span> 
                                }

                            </div>
                        </div>
                        <Errors errors={errors}/>
                        <Description description={ description } />
                    </FormGroup>
                </div>
            )
        }else{
            return null
        }
    }

}





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/standard-input.tsx